import styled from 'styled-components';
import ColumnWrapper from '../../Column';

const Column = styled(ColumnWrapper)<{ $marginRight?: number }>`
    justify-content: center;
    margin-right: ${({ $marginRight }) => $marginRight || 0}px;
`;

export default Column;
